import React, { useEffect, useState } from 'react';
import AttachmentPreview from './AttachmentPreview';

const API_BASE = process.env.REACT_APP_API_BASE;

function fileTypeFrom(name = '', contentType = '') {
  const ext = (name || '').split('.').pop().toLowerCase();
  if (contentType === 'application/pdf' || ext === 'pdf') return 'pdf';
  if (['doc','docx','msword'].includes(ext) || contentType.includes('wordprocessingml')) return 'docx';
  if ((contentType || '').startsWith('image/') || ['png','jpg','jpeg','gif'].includes(ext)) return 'image';
  return 'other';
}

export default function AttachmentIcons({ messageId }) {
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (!messageId) return;
    setLoading(true);
    setError(null);
    const encodedUrl = `${API_BASE}/attachments/messages/${encodeURIComponent(messageId)}/attachments`;
    console.debug('Fetching attachments (percent-encoded):', encodedUrl);
    fetch(encodedUrl)
      .then(r => {
        if (!r.ok) return r.text().then(t => { throw new Error(`Failed to load attachments (${r.status}) ${t||''}`)});
        return r.json();
      })
      .then(data => setAttachments(data.attachments || []))
      .catch(err => {
        console.error('Attachment icons error:', err);
        setError(err.message || 'Error');
      })
      .finally(() => setLoading(false));
  }, [messageId]);

  if (!messageId) return null;

  return (
    <div>
      <div className="attachment-icons-row" style={{ marginTop: 8 }}>
        {loading && <div className="attachment-loading">Loading attachments…</div>}
        {error && <div className="attachment-error">{error}</div>}
        {attachments.map(att => {
          const type = fileTypeFrom(att.name, att.content_type);
          return (
            <button
              key={att.id}
              className={`attachment-icon-btn att-type-${type}`}
              title={att.name}
              onClick={() => setSelected(att)}
              type="button"
            >
              <div className="attachment-icon">
                {/* simple visual: show extension label for clarity */}
                <span className="attachment-ext">{type === 'other' ? 'FILE' : type.toUpperCase()}</span>
              </div>
              <div className="attachment-label">{att.name}</div>
            </button>
          );
        })}
        {attachments.length === 0 && !loading && <div className="attachment-empty">No attachments</div>}
      </div>

      {selected && (
        <AttachmentPreview
          messageId={messageId}
          attachment={selected}
          onClose={() => setSelected(null)}
        />
      )}
    </div>
  );
}